/*
{
    'menuKey': 'desktopPush',
    'name': 'desktoppush',
    'text': '桌标推送',
    'img': '../assets/img/icon_menu_desktoppush.png',
    'subMenus': [],
  },


 */

export default {
  //菜单
  menu: [
    {
      'menuKey': '',
      'name': 'goods_manage',
      'text': '商品管理',
      'subMenus': [{
        'menuKey': 'goodsList',
        'name': '_menu:goods_manage:goodsList',
        'text': '商品列表'
      },
      {
        'menuKey': 'gameList',
        'name': '_menu:goods_manage:gameList',
        'text': '游戏列表'
      },
      ],
      'img': '../assets/img/icon_menu_goods_manage.png'
    },
    {
      'menuKey': '',
      'name': 'activity_manage',
      'text': '活动管理',
      'subMenus': [{
        'menuKey': 'pointsStore',
        'name': '_menu:activity_manage:pointsStore',
        'text': '积分商城配置'
      },{
        'menuKey': 'lotteryActivity',
        'name': '_menu:activity_manage:lotteryActivity',
        'text': '积分抽奖活动配置'
      },{
        'menuKey': 'pointsLotteryPage',
        'name': '_menu:activity_manage:pointsLotteryPage',
        'text': '积分抽奖页面配置'
      },{
        'menuKey': 'taskRecords',
        'name': '_menu:activity_manage:taskRecords',
        'text': '游戏任务管理'
      },{
        'menuKey': 'taskDataDetails',
        'name': '_menu:activity_manage:taskDataDetails',
        'text': '任务数据明细'
      },{
        'menuKey': 'gameTaskPrizes',
        'name': '_menu:activity_manage:gameTaskPrizes',

        'text': '游戏任务奖品配置'
      },{
        'menuKey': 'packetRecord',
        'name': '_menu:activity_manage:packetRecord',

        'text': '红包发放统计'
      }],
      'img': '../assets/img/icon_menu_activity_manage.png'
    },
    {
      'menuKey': '',
      'name': 'user_manage',
      'text': '用户管理',
      'subMenus': [{
        'menuKey': 'userList',
        'name': '_menu:user_manage:userList',
        'text': '用户列表'
      },{
        'menuKey': 'integralDetails',
        'name': '_menu:user_manage:integralDetails',
        'text': '积分详情'
      }],
      'img': '../assets/img/icon_menu_user_manage.png'
    },
    {
      'menuKey': '',
      'name': 'advertising_manage',
      'text': '广告管理',
      'subMenus': [{
        'menuKey': 'advertisingManage',
        'name': '_menu:advertising_manage:advertisingManage',
        'text': '广告管理'
      }],
      'img': '../assets/img/icon_menu_advertising_manage.png'
    },
    {
      'menuKey': '',
      'name': 'netBarAccount_manage',
      'text': '网关账号管理',
      'subMenus': [{
        'menuKey': 'netBarAccountManage',
        'name': '_menu:advertising_manage:netBarAccountManage',
        'text': '网关账号管理'
      }],
      'img': '../assets/img/icon_menu_netBarAccount_manage.png'
    },
    
  ]  
}



// WEBPACK FOOTER //
// ./src/utility/menu.js